import HttpClient from './HttpClient';
import AppointmentService from './appointment';
import UserService from './user';
import TimeSlotService from './timeSlot';
import AdditionalInfoService from './additionalInfo';
import StatusService from './status';
import StateService from './state';
import LanguageService from './languages';

export interface Services {
  status: StatusService;
  languages: LanguageService;
}

const {
  bokaCustomerApi,
  bokaCoworkerApi,
  bokaCustomerDRApi,
  bokaCoworkerDRApi,
} = CSS_CONFIG.backendUrl;

const shouldUseDr = (): boolean => DISASTER_RECOVERY_MODE === 'true';

const getApiBaseUrl = (): string =>
  (shouldUseDr() && bokaCustomerDRApi) || bokaCustomerApi || '';

const getBokaApiBaseUrl = (): string =>
  (shouldUseDr() && bokaCoworkerDRApi) || bokaCoworkerApi || '';

const configAppointmentService = (): AppointmentService => {
  const httpBokaCustomer = new HttpClient(getApiBaseUrl());
  const httpBokaCoworker = new HttpClient(getBokaApiBaseUrl());
  return new AppointmentService(httpBokaCustomer, httpBokaCoworker);
};

const configUserService = (): UserService => {
  const httpBokaCustomer = new HttpClient(getApiBaseUrl());
  return new UserService(httpBokaCustomer);
};

const configTimeslotService = (): TimeSlotService => {
  const httpBokaCustomer = new HttpClient(getApiBaseUrl());
  return new TimeSlotService(httpBokaCustomer);
};

const configAdditionalInfoService = (): AdditionalInfoService => {
  const httpBokaCoworker = new HttpClient(getBokaApiBaseUrl());
  return new AdditionalInfoService(httpBokaCoworker);
};

const configStatusService = (): StatusService => {
  const httpBokaCustomer = new HttpClient(getApiBaseUrl());
  return new StatusService(httpBokaCustomer);
};

const configStateService = (): StateService => {
  return new StateService();
};

const configLanguagesService = (): LanguageService => {
  const httpBokaCoworker = new HttpClient(getBokaApiBaseUrl());
  return new LanguageService(httpBokaCoworker);
};

const services = {
  appointment: configAppointmentService(),
  user: configUserService(),
  timeSlot: configTimeslotService(),
  additionalInfo: configAdditionalInfoService(),
  status: configStatusService(),
  languages: configLanguagesService(),
  state: configStateService(),
};

export default services;
